import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <Link
                to="/"
                className="flex items-center gap-2 text-xl font-bold font-heading text-background-50 mb-4 whitespace-nowrap"
              >
                <i className="ri-play-circle-fill text-2xl"></i>
                <span>国产精品视频</span>
              </Link>
              <p className="text-foreground-300 text-sm leading-relaxed">
                汇聚海量国产精品视频，涵盖剧情、纪录、综艺、短片等多元类型。精心筛选高品质国产原创内容，为您提供流畅、清晰、优质的观看体验。
              </p>
            </div>

            <div>
              <h4 className="text-background-50 font-semibold mb-4">视频分类</h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/jq" className="text-foreground-300 hover:text-background-50 text-sm transition-colors whitespace-nowrap">剧情</Link>
                <Link to="/category/jl" className="text-foreground-300 hover:text-background-50 text-sm transition-colors whitespace-nowrap">纪录</Link>
                <Link to="/category/zy" className="text-foreground-300 hover:text-background-50 text-sm transition-colors whitespace-nowrap">综艺</Link>
                <Link to="/category/dp" className="text-foreground-300 hover:text-background-50 text-sm transition-colors whitespace-nowrap">短片</Link>
              </div>
            </div>

            <div>
              <h4 className="text-background-50 font-semibold mb-4">快速链接</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-foreground-300 hover:text-background-50 text-sm transition-colors whitespace-nowrap">首页</Link>
                <Link to="/about" className="text-foreground-300 hover:text-background-50 text-sm transition-colors whitespace-nowrap">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="text-background-50 font-semibold mb-4">关注我们</h4>
              <div className="flex gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-background-50"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-background-50"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-background-50"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-400 text-sm">
              &copy; {currentYear} 国产精品视频精选推荐平台 版权所有
            </p>
            <div className="flex items-center gap-4 text-sm text-foreground-400">
              <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap">服务条款</a>
              <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}